import {
  useEffect,
  useMemo,
  useRef
} from "react";
import { useLocation, useNavigate, useParams } from "react-router";

import { DashBoardHeader } from "./components/DashBoardHeader";
import { DashBoardHeaderPlaceholder } from "./components/DashBoardHeader";
import { DashBoardTable } from "./components/DashBoardTable";
import styles from "./DashBoardLayout.module.scss";

import { useActiveSyncLogs } from "../../../hooks/useActiveSyncLogs";
import { useFileVersions } from "../../../hooks/useFileVersions";
import { getReportTemplate } from "../ReportTemplate/getReport";


export const DashBoardLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const ref = useRef<HTMLDivElement>(null);

  const { data: versions, isLoading } = useFileVersions();
  const { data: activeSyncLogs, getCurrent } = useActiveSyncLogs();

  useEffect(() => {
    if (activeSyncLogs) {
      const currentLog = getCurrent();
      if (currentLog && !params.syncLogId) {
        navigate(`${location.pathname}/${currentLog.id}`, { replace: true });
      }
    }
  }, [activeSyncLogs, getCurrent]);

  const ReportComponent = useMemo(() => getReportTemplate(params.reportId), [params.reportId]);

  return (
    <div className={styles.root}>
      {!isLoading && versions ? <DashBoardHeader layoutRef={ref} option={versions} /> : <DashBoardHeaderPlaceholder />}
      <div className={styles.wrapper} ref={ref}>
        {ReportComponent && <ReportComponent />}
        <DashBoardTable />
      </div>
    </div>
  );
};
